<template>
  <v-stepper :model-value="modelValue"
             :items="stepperItems"
             :hide-actions="true"
             :mobile="!$vuetify.display.mdAndUp"
             class="AppDialogStepper"
  >
    <template v-if="$slots['stepper-header']">
      <v-card-title class="AppDialogStepper__cardTitle">
        <v-stepper-header class="AppDialogStepper__stepperHeader">
          <slot name="stepper-header"></slot>
        </v-stepper-header>
        <AppButton v-if="closeButton"
                  class="AppDialogStepper__closeButton"
                  :disabled="cancelDisabled"
                  icon
                  variant="text"
                  density="comfortable"
                  @click="$emit('cancel')"
        >
          <font-awesome-icon :icon="['fal', 'xmark']" size="lg" />
        </AppButton>
      </v-card-title>
      <v-divider />
    </template>
    <template v-if="$slots['stepper-items']">
      <v-card-text class="AppDialogStepper__cardText">
        <v-stepper-window class="AppDialogStepper__stepperItems">
          <slot name="stepper-items"></slot>
        </v-stepper-window>
      </v-card-text>
    </template>

    <template v-for="(_, slot) in $slots" v-slot:[slot]>
      <slot :name="slot"/>
    </template>
  </v-stepper>
</template>

<script>
import AppButton from '@/common/buttons/AppButton.vue'

export default {
  name: 'AppDialogStepperTemplate',
  components: { AppButton },
  props: {
    modelValue: {
      required: true,
    },
    stepperItems: {
      type: Array,
      default: () => [],
    },
    closeButton: {
      type: Boolean,
      required: true,
    },
    cancelDisabled: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style scoped lang="scss">
.AppDialogStepper {
  overflow: auto !important;

  :deep(.v-stepper-header) {
    justify-content: center;
    box-shadow: none;

    .v-divider {
      flex-basis: 32px;
      flex-grow: 0;
    }

    .v-stepper-item {
      font-weight: 500;
    }
  }

  &__closeButton {
    position: fixed;
    top: 16px;
    right: 20px;
    z-index: 10;
    color: rgba(0, 0, 0, .54);
  }
}
</style>
